<div *ngIf="useAutoComplete">
	<mat-form-field class="full-width" floatLabel="never">
		<input
			#accountInput
			(input)="inputChanged($event.target.value)"
			[(ngModel)]="searchText"
			[matAutocomplete]="auto"
			matInput
			placeholder="Broker"
		/>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event)"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoadingAccountsList" fxLayoutAlign="center center">
				<mat-spinner [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoadingAccountsList">
				<mat-option *ngFor="let account of accountsList" [value]="account">
					{{ account.businessName }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</div>

<div *ngIf="useDropdown">
	<mat-form-field
		#popoverTrigger="mtxPopoverTrigger"
		(click)="$event.stopPropagation()"
		[mtxPopoverTriggerFor]="brokerPopover"
		class="full-width"
		floatLabel="never"
		fxFlex
		mtxPopoverTriggerOn="click"
	>
		<mat-label [ngClass]="{ 'primary-text': placeholder !== 'Broker' }" class="capitalize">{{
			placeholder
		}}</mat-label>
		<input matInput readonly="true" />
		<mat-icon *ngIf="renderDownArrowIcon()" class="vertical-align-middle" matSuffix
			>keyboard_arrow_down
		</mat-icon>
		<mat-icon
			(click)="$event.stopPropagation(); removeSelectedAccount()"
			*ngIf="renderCloseArrowIcon()"
			class="vertical-align-middle danger-text cursor-pointer"
			matSuffix
		>
			close
		</mat-icon>
	</mat-form-field>

	<mtx-popover #brokerPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="broker-account-dropdown font-size-14">
				<div class="padding-0-5" fxLayout="row">
					<mat-form-field fxFlex>
						<input
							[(ngModel)]="searchText"
							autocomplete="off"
							matInput
							placeholder="Type to filter"
						/>
					</mat-form-field>
				</div>
				<div
					(click)="setAccountSelected(account)"
					*ngFor="let account of accountsList | search: 'businessName':searchText"
					class="padding-0-5 account-row cursor-pointer"
					fxLayout="row"
				>
					<div class="primary-text" fxFlex fxLayoutAlign="start center">
						{{ account.businessName }}
					</div>
				</div>

				<div
					*ngIf="
						!isLoadingAccountsList &&
						searchText?.length > 0 &&
						(accountsList | search: 'businessName':searchText).length === 0
					"
					class="padding-0-5 account-row"
				>
					<div fxFlex fxLayoutAlign="center center">No Account found.</div>
				</div>
			</mat-card-content>
			<mat-divider *ngIf="hasNextPage"></mat-divider>

			<mat-card-actions *ngIf="hasNextPage">
				<div class="p-1 p-t-0" fxLayoutAlign="end center">
					<span
						(click)="viewMore()"
						*ngIf="!isLoadingAccountsList"
						class="text-underline primary-text cursor-pointer"
					>
						View More
					</span>
					<mat-spinner *ngIf="isLoadingAccountsList" [diameter]="30"></mat-spinner>
				</div>
			</mat-card-actions>
		</mat-card>
	</mtx-popover>
</div>
